import { render, staticRenderFns } from "./ListBnLivraisonVal.vue?vue&type=template&id=15f88cd0&"
import script from "./ListBnLivraisonVal.vue?vue&type=script&lang=js&"
export * from "./ListBnLivraisonVal.vue?vue&type=script&lang=js&"
import style0 from "./ListBnLivraisonVal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports